import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { get as _get } from 'lodash';
import classnames from 'classnames';
import IgniteDataTable from '../../../common/datatable/index';
import { linkPendingOutlet, removePendingOutlet } from '../../../../actions/users';
import { getCustomerNumbersForPendingOutlet } from '../../../../actions/outlet';

const permissions = { action: 'modify', subjectClass: 'User' };

class PendingOutletsTable extends Component {
  state = {
    selectedOutlets: {},
    requestingChanges: {}
  }

  onSearch = (value) => {
    if (!value.trim().length) return;

    this.props.dispatch(getCustomerNumbersForPendingOutlet(value));
  }

  onUpdate = (id, value) => {
    this.setState(({ selectedOutlets }) => ({
      selectedOutlets: { ...selectedOutlets, [id]: value }
    }));
  }

  onLink = ({ id }) => {
    this.setState(({ requestingChanges }) => ({
      requestingChanges: { ...requestingChanges, [id]: true }
    }));

    const { selectedOutlets } = this.state;

    linkPendingOutlet(id, selectedOutlets[id].id).finally(() =>
      this.setState(({ requestingChanges }) => ({
        requestingChanges: { ...requestingChanges, [id]: false }
      })));
  }

  onRemove = ({ id }) => {
    this.setState(({ requestingChanges }) => ({
      requestingChanges: { ...requestingChanges, [id]: true }
    }));

    removePendingOutlet(this.props.userId, id).finally(() =>
      this.setState(({ requestingChanges }) => ({
        requestingChanges: { ...requestingChanges, [id]: false }
      })));
  }

  render() {
    const { pendingOutlets, matchedOutlets, hasLinkedOutlets } = this.props;
    const { selectedOutlets, requestingChanges } = this.state;

    if (!pendingOutlets.length) return null;

    const columns = [
      {
        title: 'Customer number',
        prop: 'id',
        format: pendingOutletId => (
          <Select
            onChange={chosenOutlet => this.onUpdate(pendingOutletId, chosenOutlet)}
            onInputChange={this.onSearch}
            options={matchedOutlets}
            valueKey="id"
            placeholder="Search for a customer number..."
            value={selectedOutlets[pendingOutletId]}
          />
        )
      },
      {
        title: 'Outlet address details',
        prop: 'full_address',
        format: (address, { name }) => `${name}, ${address}`
      }
    ];

    const actions = [
      {
        permissions,
        label: 'LINK',
        callback: this.onLink,
        disabled: ({ id }) => requestingChanges[id] || !selectedOutlets[id]
      },
      {
        permissions,
        label: 'REMOVE',
        callback: this.onRemove,
        disabled: ({ id }) => requestingChanges[id]
      }
    ];

    return (
      <IgniteDataTable
        actions={actions}
        columns={columns}
        data={pendingOutlets}
        hasAttributes={false}
        tableClass={
          classnames(
            'ignite-table pending-outlets-table',
            { 'has-hidden-header': hasLinkedOutlets }
          )
        }
      />
    );
  }
}

const mapStateToProps = ({ users: { user }, customer_numbers: { unlinkedOutlets }}) => ({
  pendingOutlets: _get(user, 'relationships.pending-outlets.data', []),
  hasLinkedOutlets: _get(user, 'relationships.outlets.data', []).length > 0,
  userId: user.id,
  matchedOutlets: unlinkedOutlets.map(outlet => ({
    ...outlet,
    label: `${outlet.attributes['customer-number']} - ${outlet.attributes.name}`
  }))
});

export default connect(mapStateToProps)(PendingOutletsTable);



// WEBPACK FOOTER //
// ./src/components/admin/users/edit/pending-outlets-table.jsx